const chartPalette = [
  { hex: '#637eff', variable: 'indigo' },
  { hex: '#3abefa', variable: 'aqua' },
  { hex: '#1dc463', variable: 'green' },
  { hex: '#fca000', variable: 'yellow' },
  { hex: '#c363e5', variable: 'purple' },
];

export const stages = [
  {
    accent: chartPalette[0],
    key: 'visitors',
    label: 'Visits',
    chartColor: 'dataVizA',
    tooltip:
      'Number of page views from companies where at least one person from that company were present in your Clearbit advertising audiences',
  },
  {
    accent: chartPalette[1],
    key: 'leads',
    label: 'Leads',
    tooltip: 'Leads tooltip content goes here',
  },
  {
    accent: chartPalette[2],
    key: 'mqls',
    label: 'MQLs',
    tooltip: 'MQLs tooltip content goes here',
  },
  {
    accent: chartPalette[3],
    key: 'opportunities',
    label: 'Opportunities',
    chartColor: 'dataVizB',
    tooltip:
      'Opportunities created within the date range for accounts that were targeted in your Clearbit advertising audiences',
  },
  {
    accent: chartPalette[4],
    key: 'dealsWon',
    label: 'Deals won',
    chartColor: 'dataVizD',
    tooltip:
      'Opportunities that were Closed Won within the date range for accounts that were targeted in your Clearbit advertising audiences',
  },
];
